import api from 'api'
import { WageRule } from './getRule'

type UpdateRuleRequest = {
  ruleId: number
  effectiveEnd?: string | null
  reference?: string | null
}

export const updateRule = async (
  request: UpdateRuleRequest
): Promise<WageRule> => {
  const response = await api.patch<WageRule>(
    `/admin/wage/rules/${request.ruleId}`,
    {
      effectiveEnd: request.effectiveEnd,
      reference: request.reference,
    }
  )
  return response.data
}
